/** Minimum length for newly set passwords (registration, staff/student accounts, profile change). */
export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_MIN_HELPER = `At least ${MIN_PASSWORD_LENGTH} characters`;

/** @returns {string|null} Error message, or null if valid. */
export function validateNewPassword(password) {
    const p = String(password ?? "").trim();
    if (!p) return "Password is required";
    if (p.length < MIN_PASSWORD_LENGTH) {
        return `Password must be at least ${MIN_PASSWORD_LENGTH} characters`;
    }
    return null;
}

/** For optional password fields (profile update). */
export function validatePasswordIfProvided(password) {
    const p = String(password ?? "").trim();
    if (!p) return null;
    if (p.length < MIN_PASSWORD_LENGTH) {
        return `Password must be at least ${MIN_PASSWORD_LENGTH} characters`;
    }
    return null;
}
